import React, { useEffect, useState } from "react";
import { FaLeftLong } from "react-icons/fa6";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import { FiShare } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { BiSolidCategory } from "react-icons/bi";
import { toast } from "sonner";
import { FaRegUser } from "react-icons/fa6";
import { MapPinIcon } from "@heroicons/react/24/outline";
import { RiGiftLine } from "react-icons/ri";

const Vendors = () => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAllVendors, setShowAllVendors] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    fetch("https://api.upswap.app/api/vendor/lists/")
      .then((res) => res.json())
      .then((data) => {
        console.log("API Response (Vendors List):", data);
        setVendors(data?.vendors || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching vendors:", err);
        setLoading(false);
        toast.error("Failed to fetch popular vendors.");
      });
  }, []);

  // Determine which vendors to display based on showAllVendors state
  const displayedVendors = showAllVendors ? vendors : vendors.slice(0, 12);

  // Only show the button if there are more than 6 vendors
  const shouldShowToggleButton = vendors.length > 12;

  const handleToggleView = () => {
    setShowAllVendors((prevState) => !prevState);
  };

  return (
    <div className="bg-white">
      <div className="py-8 px-4 sm:px-6 md:px-8 max-w-screen-2xl mx-auto">
        {/* Section Header - Matching Deals component styling */}
        <div className="flex justify-between items-center mb-8">
          <div>
            <button
              onClick={() => navigate("/Home")}
              className="text-black text-sm px-1 py-1 rounded-md"
            >
              <div className="flex items-center gap-2">
                <FaLeftLong className="w-7 h-6 bg-orange-500 hover:bg-red-500 text-white rounded-md p-1" />
                <h2 className="text-4xl font-bold">Popular Vendors</h2>
              </div>
            </button>
            <p className="text-gray-600">Discover trusted local businesses</p>
          </div>

          {shouldShowToggleButton && (
            <button
              onClick={handleToggleView}
              className="
                flex items-center text-base font-semibold text-orange-500
                hover:text-orange-600 transition-colors duration-200
              "
            >
              {showAllVendors ? (
                <>
                  Show Less <FaArrowLeft className="ml-2 w-4 h-4" />
                </>
              ) : (
                <>
                  View all vendors <FaArrowRight className="ml-2 w-4 h-4" />
                </>
              )}
            </button>
          )}
        </div>

        {/* Loader */}
        {loading ? (
          <div className="flex justify-center items-center p-10">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
          </div>
        ) : (
          <>
            {vendors.length === 0 && (
              <div className="text-center text-gray-600">
                No popular vendors found.
              </div>
            )}

            {/* Vendor Cards Grid - Matching Deals component grid layout */}
            <div
              className="
                grid gap-4
                grid-cols-1
                sm:grid-cols-2
                md:grid-cols-3
                lg:grid-cols-4
                xl:grid-cols-6
                2xl:grid-cols-6
              "
            >
              {displayedVendors.map((vendor) => (
                <div
                  key={vendor.vendor_id}
                  className="
                    border border-gray-200 rounded-lg overflow-hidden
                    bg-white shadow-md cursor-pointer
                    transition-transform duration-200 hover:scale-[1.01]
                  "
                >
                  <div className="relative h-36 overflow-hidden">
                    <img
                      src={vendor.profile_pic || "/duplicate (1).png"}
                      alt={vendor.full_name}
                      className="w-full h-full object-cover rounded-t-lg"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/duplicate (1).png";
                      }}
                    />
                  </div>

                  <div className="p-3">
                    <h3 className="font-semibold text-base leading-tight mb-2 flex items-center gap-1">
                      {/* <span>👥</span> */}
                      <FaRegUser className="opacity-70" />
                      <span>{vendor.full_name}</span>
                    </h3>

                    <p className="text-xs text-gray-500 flex items-center gap-2 mb-2">
                      <RiGiftLine className="text-base text-gray-500" />
                      <span className="font-medium text-[#EF4444]">
                        {vendor.services?.[0]?.item_name || "N/A"}
                      </span>
                    </p>

                    <p className="text-xs text-gray-500 mb-2 flex items-center gap-1">
                      <MapPinIcon className="w-4 h-4 text-gray-500" />
                      <span className="font-medium text-gray-700">
                        {vendor.addresses?.[0]?.road_name_area_colony || "N/A"}
                      </span>
                    </p>

                    <div className="flex gap-2 justify-between mt-4">
                      {/* Share Icon on the right */}

                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate(`/vendor/${vendor.vendor_id}`);
                        }}
                        className="
              py-1.5 px-3 bg-orange-500 text-white
              rounded-md font-medium text-sm
              hover:bg-orange-600 transition-colors duration-200
              whitespace-nowrap
            "
                      >
                        View Profile
                      </button>
                      <button
                        className="p-2 rounded-md bg-white text-gray-700 hover:bg-gray-100 transition-colors duration-200"
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent card's onClick from firing
                          toast.info("Share functionality coming soon!");
                        }}
                      >
                        <FiShare className="w-5 h-5 text-gray-500 opacity-70" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Vendors;

// import React, { useEffect, useState } from "react";
// import {
//   FaUser,
//   FaBriefcase,
//   FaMapMarkerAlt,
//   FaShare,
//   FaArrowRight,
//   FaArrowLeft,
// } from "react-icons/fa";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import { BiSolidCategory } from "react-icons/bi";

// const Vendors = () => {
//   const [vendors, setVendors] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showAllVendors, setShowAllVendors] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     setLoading(true);
//     fetch("https://api.upswap.app/api/vendor/lists/")
//       .then((res) => res.json())
//       .then((data) => {
//         console.log("API Response (Vendors List):", data);
//         setVendors(data?.vendors || []);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error fetching vendors:", err);
//         setLoading(false);
//         toast.error("Failed to fetch popular vendors.");
//       });
//   }, []);

//   // Determine which vendors to display based on showAllVendors state
//   const displayedVendors = showAllVendors ? vendors : vendors.slice(0, 6);

//   // Only show the button if there are more than 6 vendors
//   // const shouldShowToggleButton = vendors.length > 6;

//   const handleToggleView = () => {
//     setShowAllVendors((prevState) => !prevState);
//   };

//   return (
//     <div className="bg-white">
//       <div className="py-8 px-4 sm:px-6 md:px-8 max-w-screen-2xl mx-auto">
//         {/* Section Header - Matching Deals component styling */}
//         <div className="flex justify-between items-center mb-8">
//           <div>
//             <h2 className="text-4xl leading-10 font-bold text-gray-900 mb-2">
//               Popular Vendors
//             </h2>
//             <p className="text-lg leading-7 text-gray-700">
//               Discover trusted local businesses
//             </p>
//           </div>
//           {/* {shouldShowToggleButton && (
//             <button
//               onClick={handleToggleView}
//               className="
//                 flex items-center text-base font-semibold text-orange-500
//                 hover:text-orange-600 transition-colors duration-200
//               "
//             >
//               {showAllVendors ? (
//                 <>
//                   Show Less <FaArrowLeft className="ml-2 w-4 h-4" />
//                 </>
//               ) : (
//                 <>
//                   View all vendors <FaArrowRight className="ml-2 w-4 h-4" />
//                 </>
//               )}
//             </button>
//           )} */}
//         </div>

//         {/* Loader */}
//         {loading ? (
//           <div className="flex justify-center items-center p-10">
//             <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
//           </div>
//         ) : (
//           <>
//             {vendors.length === 0 && (
//               <div className="text-center text-gray-600">
//                 No popular vendors found.
//               </div>
//             )}

//             {/* Vendor Cards Grid - Matching Deals component grid layout */}
//             <div
//               className="
//                 grid gap-4
//                 grid-cols-1
//                 sm:grid-cols-2
//                 md:grid-cols-3
//                 lg:grid-cols-4
//                 xl:grid-cols-6
//                 2xl:grid-cols-6
//               "
//             >
//               {displayedVendors.map((vendor) => (
//                 <div
//                   key={vendor.vendor_id}
//                   className="
//                     border border-gray-200 rounded-lg overflow-hidden
//                     bg-white shadow-md cursor-pointer
//                     transition-transform duration-200 hover:scale-[1.01]
//                   "
//                 >
//                   <div className="relative h-36 overflow-hidden">
//                     <img
//                       src={vendor.profile_pic || "/duplicate (1).png"}
//                       alt={vendor.full_name}
//                       className="w-full h-full object-cover rounded-t-lg"
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         e.target.src = "/duplicate (1).png";
//                       }}
//                     />
//                   </div>

//                   <div className="p-3">
//                     {/* <h3 className="font-semibold text-base leading-tight mb-2 gap-8 flex items-center">
//                        👥{vendor.full_name}
//                     </h3> */}
//                     <h3 className="font-semibold text-base leading-tight mb-2 flex items-center gap-1">
//                       <span>👥</span>
//                       <span>{vendor.full_name}</span>
//                     </h3>

//                     {/* <p className="text-xs text-gray-500">
//                          <BiSolidCategory className="text-base text-orange-500" />
//                       <span className="font-medium text-[#EF4444]">

//                         {vendor.services?.[0]?.item_name || "N/A"}
//                       </span>
//                     </p> */}

//                     <p className="text-xs text-gray-500 flex items-center gap-2 mb-2">
//                       <BiSolidCategory className="text-base text-orange-500" />
//                       <span className="font-medium text-[#EF4444]">
//                         {vendor.services?.[0]?.item_name || "N/A"}
//                       </span>
//                     </p>

//                     <p className="text-xs text-gray-500 mb-2">
//                       📍{" "}
//                       <span className="font-medium text-gray-700">
//                         {vendor.addresses?.[0]?.road_name_area_colony || "N/A"}
//                       </span>
//                     </p>

//                     <div className="flex gap-2 justify-between mt-4">
//                       <button
//                         className="
//                           p-1.5 border border-gray-300 rounded-md bg-white text-gray-700
//                           flex items-center justify-center
//                           hover:bg-gray-100 transition-colors duration-200
//                         "
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           toast.info("Share functionality coming soon!");
//                         }}
//                       >
//                         <FaShare className="w-4 h-4" />
//                       </button>
//                       <button
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           navigate(`/vendor/${vendor.vendor_id}`);
//                         }}
//                         className="
//                           flex-grow py-1.5 px-3 bg-orange-500 text-white
//                           rounded-md font-medium text-sm
//                           hover:bg-orange-600 transition-colors duration-200
//                           whitespace-nowrap
//                         "
//                       >
//                         View Profile
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Vendors;
